<template>
  <div id="app">
    <router-view />
    <GlobalUploadStatus />
  </div>
</template>

<script>
import GlobalUploadStatus from '@/components/GlobalUploadStatus.vue';
import { mapState } from 'vuex';

export default {
  name: 'App',
  components: {
    GlobalUploadStatus
  },
  computed: {
    ...mapState(['darkMode'])
  },
  watch: {
    darkMode(newValue) {
      this.updateBodyDarkMode(newValue);
    }
  },
  mounted() {
    // Aplica dark mode na inicialização
    this.updateBodyDarkMode(this.darkMode);
  },
  methods: {
    updateBodyDarkMode(isDark) {
      if (isDark) {
        document.body.classList.add('dark-modeBody');
      } else {
        document.body.classList.remove('dark-modeBody');
      }
    }
  }
}
</script>

<style>
  html {
    overflow-x: hidden;
    overflow-y: auto;
  }
</style>
